import React, { useState, useEffect } from 'react'
import { Container, Grow, Grid } from '@material-ui/core'
import { Button, Typography, Paper, FormControl } from '@material-ui/core'
//import Form from '../Form/Form'
import { Link } from 'react-router-dom'
import { URL } from '../../constants/actionTypes'
import FormViewColorMixing from '../Form/FormViewColorMixing'
import useStyles from './styles'
import { useNavigate } from 'react-router-dom'

const Home = ({ checkPassword }) => {
  const classes = useStyles()
  const navigate = useNavigate()

  useEffect(() => {
    if (!checkPassword) {
      const loginSuccess = JSON.parse(localStorage.getItem('colorMixingHipic'))
      const clientSuccess = JSON.parse(
        localStorage.getItem('colorMixingPasswordHipic')
      )
      console.log(loginSuccess)
      console.log(clientSuccess)

      if (loginSuccess === null) {
        if (clientSuccess === null) {
          navigate(URL + '/password')
          navigate(0)
        }
      }
    }
  }, [])
  return (
    <Grow in style={{ backgroundColor: 'transparent' }}>
      <Container
        className='PageViewLogs'
        style={{ paddingLeft: '10px', paddingRight: '10px' }}
      >
        <Grid
          container
          justifyContent='space-between'
          alignItems='stretch'
          style={{ backgroundColor: 'transparent' }}
        >
          <Grid item xs={12} sm={12} style={{ backgroundColor: 'transparent' }}>
            <FormViewColorMixing />
          </Grid>
        </Grid>
      </Container>
    </Grow>
  )
}

export default Home
